<template>
  <div>
    <b-nav pills vertical>
      <b-nav-item>
        <router-link to="/about/introduction"
          ><span>&#187;</span>平台介绍</router-link
        >
      </b-nav-item>
      <b-nav-item>
        <router-link to="/about/history"
          ><span>&#187;</span>历史沿革</router-link
        >
      </b-nav-item>
      <b-nav-item>
        <router-link to="/about/team"><span>&#187;</span>管理团队</router-link>
      </b-nav-item>
      <b-nav-item>
        <router-link to="/about/organization"
          ><span>&#187;</span>组织架构</router-link
        >
      </b-nav-item>
    </b-nav>
  </div>
</template>
<script>
export default {};
</script>
<style lang="scss" scoped>
</style>
